import { withoutBasePath } from '@belong/url-utils';
import type { Router } from 'next/router';
import { findParentNextRouter } from './findParentNextRouter';

const navigateParentToExternalPage = (url: string): void => {
  window.parent.location.assign(url);
};

// If destination is within the current (at window.parent) app and a Next Router is available, do SPA routing,
// otherwise do full page load.
// When not in an iframe, should behave as normal. When iframed, should always change window.parent's location.
export const redirectParentTo = (route: string): ReturnType<Router['push']> | void => {
  const parentRouter = findParentNextRouter();
  // Should this get basePath from window.parent.process.env.NEXT_PUBLIC_BASE_PATH? or are they always the same?
  const parentBasePath = parentRouter?.basePath;
  const shouldUseNextRouter = parentRouter && parentBasePath && route.startsWith(parentBasePath);

  return shouldUseNextRouter
    ? parentRouter.push(withoutBasePath(route, parentBasePath))
    : navigateParentToExternalPage(route);
};
